<template>
  <div>
    <nav
      class="navbar is-warning is-overlay"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
          <img :src="require('../assets/NAVBAR.png')" />
        </router-link>
        <a
          role="button"
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          @click="isActive = !isActive"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu" v-bind:class="{ 'is-active': isActive }">
        <!-- navbar start, navbar end -->
        <div class="navbar-end">
          <router-link
            class="has-text-weight-bold navbar-item is-warning"
            to="/"
          >
            Home
          </router-link>
          <router-link
            class="has-text-weight-bold navbar-item is-warning"
            to="/resume"
          >
            Resume
          </router-link>
          <router-link
            class="has-text-weight-bold navbar-item is-warning"
            to="/projects"
          >
            Projects
          </router-link>
          <router-link
            class="has-text-weight-bold navbar-item is-warning"
            to="/contact"
          >
            Contact
          </router-link>
        </div>
      </div>
    </nav>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      isActive: false
    };
  },

  methods: {
    setMenuLink: function() {}
  },

  watch: {
    $route() {
      if (this.$route.path === "") {
        this.isActive = !this.isActive;
      } else {
        this.isActive = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  padding: 1rem;
  margin: 0.5rem;
}
.navbar-burger {
  height: 5rem;
  width: 4rem;
}

.router-link-exact-active a {
  color: inherit;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
